import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CloseIconButton from "../../../../components/CloseIconButton";
import { QrCodeIcon } from "@heroicons/react/24/solid";

interface OfficeCarrierProducerCodeModalProps {
  showFullView: boolean;
  closeFullView: () => void;
  officeCode: string;
}

export const OfficeCarrierProdCodeModal: React.FC<
  OfficeCarrierProducerCodeModalProps
> = ({ showFullView, closeFullView, children, officeCode }) => {
  return (
    <>
      <Transition appear show={showFullView} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-20 overflow-y-auto bg-black bg-opacity-40 py-10"
          onClose={() => {}}
        >
          <div className="min-h-full text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>
            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle overflow-auto"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="sm:w-4/5 md:w-7/5 lg:w-10/12 inline-block border-quinary border-l-4 px-4 pb-3 pt-2 text-left align-middle transition-all 
                  transform bg-white shadow-xl brContainer relative"
              >
                <div className="flex items-center space-x-2 pb-2 border-b-2 border-secondary">
                  <div>
                    <QrCodeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                  </div>
                  <div className="flex flex-row items-center space-x-2 text-sm ">
                    <div className="font-medium">Carrier Producer Codes </div>
                  </div>
                </div>

                <div>{children}</div>
                <CloseIconButton onClick={closeFullView} />
                <div className="text-xs max-h-fit"></div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
